// extracted by mini-css-extract-plugin
export default {"overlay":"zy-z","bodyOpen":"Ay-z","content":"By-z","header":"Cy-z","close":"Dy-z","closeNoHeading":"Ey-z"};